module.exports = __webpack_public_path__ + "static/Golem_Clay-adf4be89ce63febb5bc4584768e3d1fb.jpg";